import { IFlatAddOnDescriptor } from "../types";

/**
 * @deprecated. Kept only so it stays hidden from customers until it is truly
 * gone, at which point this whole folder is deleted.
 */
const semanticSearch = {
  productType: "semantic-search",
  kind: "flat",
  title: "Semantic search",
} satisfies IFlatAddOnDescriptor;

export default semanticSearch;
